import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  private messageSource = new BehaviorSubject('default company');
  currentMessage = this.messageSource.asObservable();
  private nexturl:string = "";

  constructor() { }

  changeCompany(comp:any) {
    this.messageSource.next(comp)
  }

  setNextUrl(url:string) {
      if(url) {
         this.nexturl = url;
      }
  }


  getNextUrl() {
      return this.nexturl;
  }

}
